<template>
  <v-form ref="form" v-model="valid" style="font-family:Microsoft JhengHei;">
    <div id="mapDiv" class="map"></div>
    <v-container>
      <!-- <svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M18,11H6V6H18M16.5,17A1.5,1.5 0 0,1 15,15.5A1.5,1.5 0 0,1 16.5,14A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 16.5,17M7.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,14A1.5,1.5 0 0,1 9,15.5A1.5,1.5 0 0,1 7.5,17M4,16C4,16.88 4.39,17.67 5,18.22V20A1,1 0 0,0 6,21H7A1,1 0 0,0 8,20V19H16V20A1,1 0 0,0 17,21H18A1,1 0 0,0 19,20V18.22C19.61,17.67 20,16.88 20,16V6C20,2.5 16.42,2 12,2C7.58,2 4,2.5 4,6V16Z"
        />
      </svg>-->
      <!-- <v-icon>mdi-bus</v-icon>
      <img :src="{{url:}}" alt="">
      {{require('../../assets/marker-a.png')}}
      {{require('../../assets/bus.png') }}-->
      <!--<v-row dense>
        <v-col>Width: {{ screenWidth }}  Height: {{ screenHeight }}</v-col>
      </v-row>
      -->
      <v-row dense>
        <v-col cols="12" xs="12" sm="6" md="6">
          <v-text-field
            label="License Plate Number"
            v-model="queryObject.plate"
            dense
            @keyup="searchObject"
          />
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6">
          <v-text-field label="Type" dense />
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6">
          <v-text-field label="Driver Name" dense />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" xs="12" sm="6" md="6">
          <v-btn color="#f7f409" block @click="resetObject">
            <font style="color:black">Clear</font>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-toolbar-title>
          <v-row class="pa-3 ma-5" align="center" justify="center">
            <span style="color:#239e46;">Total {{totalCount}} , Page Size</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn dark text color="#239e46" class="ml-2" v-on="on">
                  {{ pageSize }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(number, index) in itemsPerPageArray"
                  :key="index"
                  @click="updateItemsPerPage(number)"
                >
                  <v-list-item-title>{{ number }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-col>
              <v-col cols="12" md="12">
                <v-btn color="#f7f409" block @click="addAllItems">
                  <font style="color:black">Select All</font>
                </v-btn>
              </v-col>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-col cols="12" sm="10" md="10">
          <v-data-iterator
            :items="items"
            :items-per-page.sync="pageSize"
            :page="currentPage"
            hide-default-footer
            no-data-text="No Data"
          >
            <template v-slot:default="props">
              <v-row>
                <v-col v-for="(item,i) in props.items" :key="i" cols="12" sm="5" md="5" lg="6">
                  <v-card>
                    <v-card-title v-bind:class="{'green darken-2 white--text':isItemExist(item)}">
                      <h3>{{ item.plate }}</h3>
                      <h5>({{ item.type }})</h5>
                      <v-spacer />
                      <!-- <v-btn v-if="isHeartExist(item)" @click="deleteHeart(item)" class="ma-1">
                        <v-icon color="red">turned_in</v-icon>
                      </v-btn>
                      <v-btn v-if="!isHeartExist(item)" @click="addHeart(item)" class="ma-1">
                        <v-icon>turned_in_not</v-icon>
                      </v-btn>-->

                      <v-btn
                        @click="dialog = !dialog;memberItem = item;"
                        class="ma-1"
                        color="#f7f409"
                      >
                        <v-icon>search</v-icon>
                      </v-btn>
                      <v-btn
                        @click="selectedArrayPushObject(item);updateTargetId(item.name);addAlertUtil();"
                        class="ma-1"
                        v-if="!isItemExist(item)"
                        color="#f7f409"
                      >
                        <v-icon>mdi-account-plus</v-icon>
                      </v-btn>
                      <v-btn
                        @click="selectedArray.splice(findItemIndex(item),1)"
                        v-if="isItemExist(item)"
                        class="ma-1"
                        color="#f7f409"
                      >
                        <v-icon>mdi-account-remove</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-list dense>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content class="align-end" v-on="on">{{ item.driverName }}</v-list-item-content>
                          </template>
                          <span>Driver Name</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ convertDBDateTimeToString(item.modifierDate) }}</v-list-item-content>
                          </template>
                          <span>Update Time</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content class="align-end" v-on="on">{{ item.nextStop }}</v-list-item-content>
                          </template>
                          <span>Next Stop</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content class="align-end" v-on="on">{{ item.destination }}</v-list-item-content>
                          </template>
                          <span>Destination</span>
                        </v-tooltip>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </template>
            <template v-slot:footer>
              <!-- <span style="color:#239e46;">每頁筆數</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn dark text color="red" class="ml-2" v-on="on">
                      {{ pageSize }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(number, index) in itemsPerPageArray"
                      :key="index"
                      @click="updateItemsPerPage(number)"
                    >
                      <v-list-item-title>{{ number }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-spacer></v-spacer>

                <span class="mr-4 red--text">Page {{ page }} / {{ maxPage }}</span>
                <v-btn fab dark color="red darken-3" class="mr-1" @click="formerPage">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn fab dark color="red darken-3" class="ml-1" @click="nextPage">
                  <v-icon>mdi-chevron-right</v-icon>
              </v-btn>-->

              <div class="text-center pa-2 ma-2">
                <v-pagination
                  color="#239e46"
                  v-model="currentPage"
                  :length="maxPage"
                  :total-visible="9"
                  @input="getInterpreterFromServer()"
                ></v-pagination>
              </div>
            </template>
          </v-data-iterator>
        </v-col>
        <v-col cols="12" md="2">
          <v-card
            v-show="selectedArray.length != 0"
            :style="{'top':offsetTop+'px','transition': 'all 0.5s'} "
          >
            <v-card-title class="green darken-2 white--text">
              <h4>Selected：{{selectedArray.length}}</h4>
            </v-card-title>
            <v-spacer />
            <v-card-text v-for="(selectedItem,j) in selectedArray" :key="j">
              <h4>
                {{selectedItem.plate}}
                <v-btn fab x-small @click="selectedArray.splice(j,1)">
                  <v-icon>mdi-account-remove</v-icon>
                </v-btn>
              </h4>
            </v-card-text>
            <v-card-actions>
              <v-btn color="#f7f409" block @click="submitObject">
                <font style="color:black">Information</font>
              </v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn color="#f7f409" block @click="selectedArray=[]">
                <font style="color:black">Clear All</font>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="10">
          <gmap-map
            :center="selectedArray[0]"
            :zoom="12"
            style="width: 900px; height: 600px"
            v-if="selectedArray.length >0"
          >
            <gmap-marker
              v-for="(postion,index) in selectedArray"
              :key="index"
              :position="postion"
              :clickable="true"
              @click="center=postion"
              :label="{text:postion.plate,color:'#006030',fontSize:'18px'}"
              :icon="icon"
            ></gmap-marker>

            <!-- <gmap-polyline
              v-bind:path.sync="selectedArray"
              v-bind:options="{ strokeColor:'#008000'}"
            ></gmap-polyline>-->
          </gmap-map>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" width="1000px" v-if="dialog">
      <BusDetail :memberItem="memberItem" v-on:childDialog="parentDialog"></BusDetail>
    </v-dialog>
  </v-form>
</template>

<script >
import BusDetail from "../components/Common/BusDetail";
import { mapGetters, mapActions } from "vuex";

import { API_KEY } from "./API_KEY";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: API_KEY,
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
});

// import { Loader, LoaderOptions } from "google-maps";

// const loader = new Loader(API_KEY, LoaderOptions);

export default {
  components: {
    BusDetail
  },
  computed: {
    ...mapGetters({
      getUserId: ["getUserId"],
      getTargetId: ["getTargetId"],
      getIcArray: ["getIcArray"],
      getSearchCase: ["getSearchCase"],
      getQueryObject: ["getQueryObject"],
      idbServerUrl: ["getIdbServerUrl"]
    })
  },
  data() {
    return {
      timer: false,
      timer2: false,
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight,
      // date: new Date().toISOString().substr(0, 10),
      requiredRules: [v => !!v || "此欄位是必填，否則查無資料"],
      memberItem: {},
      date: null,
      menu: false,
      dialog: false,
      valid: false,
      firstname: "",
      lastname: "",
      nameRules: [
        v => !!v || "Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      rating: 3.5,
      selectedArray: [],
      selectOption: ["A", "B"],
      itemsPerPageArray: [1, 4, 8, 12],
      currentPage: 1,
      maxPage: 0,
      pageSize: 4,
      totalCount: 0,
      items: [],
      fakeItems: this.getFakeModel("bus"),
      districtArray1: this.getCodeDateUtil("district"),
      districtArray2: [],
      city: String,
      searchCase: {},
      queryObject: {},
      dayArray: this.getCodeDateUtil("dayType"),
      heartArray: [],
      userProfile: JSON.parse(this.$localStorage.get("userProfileStr")),
      offsetTop: 0,
      icon: {
        labelOrigin: { x: 8, y: -4 },
        url:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAAASAAAAEgARslrPgAAAM5JREFUSMftlTEKwjAUhj+lnWxHJ72BR3H0Hj2AjnoZ0dkL6A30CN1El+KkUJcXkLRpX1JQhH4QQpI/70/SJg/+nYGjPwYWwByYAWNgBKQyXgAP4ApcgAOwB14a06lMKj3LGZhoDHYBwU3ZagzuHQxuGgMj9qV23jAgkBe9QStRw1jIh/7+Dn5qsAQSYNVRU8FcmETaKe6bW6dp3UEudSYBsobF2JocBRvC36K1HawuH0TA0+dMP4ixcoIr4ZQKjUrr+otOUh8Vq/bR9lR5A49NXsOJN+ZIAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIwLTA0LTE4VDAzOjM5OjU2KzAwOjAw4kwlRwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMC0wNC0xOFQwMzozOTo1NiswMDowMJMRnfsAAAAodEVYdHN2ZzpiYXNlLXVyaQBmaWxlOi8vL3RtcC9tYWdpY2stcXFUSld0dHJ2lhxiAAAAAElFTkSuQmCC"
      },
      markerOptions: {
        path:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Interactive_icon.svg/1200px-Interactive_icon.svg.png",
        url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Interactive_icon.svg/1200px-Interactive_icon.svg.png",
        size: { width: 160, height: 90, f: "px", b: "px" },
        scaledSize: {
          width: 20,
          height: 20,
          f: "px",
          b: "px"
        },
        status:
          "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE4LDExSDZWNkgxOE0xNi41LDE3QzE1LjY3LDE3IDE1LDE2LjMzIDE1LDE1LjVDMTUsMTQuNjcgMTUuNjcsMTQgMTYuNSwxNEMxNy4zMywxNCAxOCwxNC42NyAxOCwxNS41QzE4LDE2LjMzIDE3LjMzLDE3IDE2LjUsMTdNNy41LDE3QzYuNjcsMTcgNiwxNi4zMyA2LDE1LjVDNiwxNC42NyA2LjY3LDE0IDcuNSwxNEM4LjMzLDE0IDksMTQuNjcgOSwxNS41QzksMTYuMzMgOC4zMywxNyA3LjUsMTdNNCwxNkM0LDE2Ljg4IDQuMzksMTcuNjcgNSwxOC4yMlYyMEM1LDIwLjU1IDUuNDUsMjEgNiwyMUg3QzcuNTUsMjEgOCwyMC41NSA4LDIwVjE5SDE2VjIwQzE2LDIwLjU1IDE2LjQ1LDIxIDE3LDIxSDE4QzE4LjU1LDIxIDE5LDIwLjU1IDE5LDIwVjE4LjIyQzE5LjYxLDE3LjY3IDIwLDE2Ljg4IDIwLDE2VjZDMjAsMi41IDE2LjQyLDIgMTIsMkM3LjU4LDIgNCwyLjUgNCw2VjE2WiIgLz48L3N2Zz4="
      }
    };
  },
  methods: {
    ...mapActions([
      "updateUser",
      "updateTargetId",
      "updateIcArray",
      "updateSearchCase",
      "updateQueryObject",
      "updateTargetCaseId"
    ]),
    resetObject() {
      let vm = this;
      vm.searchCase = {};
      vm.queryObject = {};
      vm.selectedArray = [];

      vm.updateIcArray(vm.selectedArray);
      vm.updateQueryObject(vm.queryObject);
      vm.updateSearchCase(vm.searchCase);

      vm.items = [];
      vm.currentPage = 1;
      vm.maxPage = 0;
      vm.pageSize = 4;
      vm.totalCount = 0;
      // this.getInterpreterFromServer();
      vm.searchObject();
    },
    addAllItems() {
      let vm = this;
      vm.items.forEach(item => {
        vm.selectedArrayPushObject(item);
      });
    },
    getDataByDistrict() {
      let vm = this;
      if (vm.isNotBlankUtil(vm.searchCase.searchDistrict))
        vm.queryObject.serviceCity = vm.searchCase.searchDistrict;
      vm.getInterpreterFromServer();
      vm.queryObject.serviceCity = vm.queryObject.serviceCity.split("-")[0];
    },
    submitObject() {
      var vm = this;
      vm.$router.push({
        path: "/Test01_2"
      });
      // var queryCloseCase = {};
      // if (
      //   vm.userProfile.memberAccount.type == "AAA" &&
      //   !vm.userProfile.sysAdmin
      // ) {
      //   queryCloseCase.deptId = vm.userProfile.memberAccount.mainDeptId;
      // }
      // queryCloseCase.status = "C04";
      // var queryCloseCaseStr = JSON.stringify(queryCloseCase);

      // var queryPagerStr = JSON.stringify({
      //   pageSize: 10,
      //   currentPage: 1
      // });

      // var criterionStr = JSON.stringify({
      //   isNull: [{ propertyName: "isCommentToInterpreter" }]
      // });
      // vm.axios
      //   .get(
      //     vm.idbServerUrl +
      //       "idb/interpreterCase?queryString=" +
      //       encodeURIComponent(queryCloseCaseStr) +
      //       "&queryPager=" +
      //       encodeURIComponent(queryPagerStr) +
      //       "&criterion=" +
      //       encodeURIComponent(criterionStr),
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //         Authorization: vm.$localStorage.get("idb_login_token")
      //       }
      //     }
      //   )
      //   .then(function(response) {
      //     // vm.tableData = response.data.resultList;
      //     var totalCount = response.data.totalCount;
      //     if (totalCount == 0) {
      //       vm.updateIcArray(vm.selectedArray);
      //       vm.updateQueryObject(vm.queryObject);
      //       vm.updateSearchCase(vm.searchCase);
      //       vm.updateTargetCaseId("");
      //       vm.$router.push({
      //         path: "/contactInterpreter"
      //       });
      //     } else {
      //       vm.alertMessageUtil("已結案之案件尚未評價，評價後才能再開新案");
      //     }
      //   })
      //   .catch(function(error) {
      //     vm.handErrorUtil(error);
      //     console.log(error);
      //   });
    },
    isItemExist(item) {
      let vm = this;
      return vm.selectedArray.some(function(element) {
        return item.plate == element.plate;
      });
    },
    isHeartExist(item) {
      let vm = this;
      return vm.heartArray.some(function(element) {
        return item.uuid == element.pocketMemberId;
      });
    },
    addHeart(item) {
      let vm = this;
      var data = {
        memberId: vm.userProfile.memberAccount.uuid,
        pocketMemberId: item.uuid
      };
      vm.axios
        .post(vm.idbServerUrl + "idb/member/pocketMember", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: vm.$localStorage.get("idb_login_token")
          }
        })
        .then(function(response) {
          vm.heartArray.push(response.data);
          console.log("response " + JSON.stringify(response));
          console.log("SUCCESS!!!!!!! ");
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log("!!!! " + error);
        });
    },
    deleteHeart(item) {
      let vm = this;
      var pocket = vm.heartArray.find(function(element) {
        return item.uuid == element.pocketMemberId;
      });
      vm.axios
        .delete(
          vm.idbServerUrl + "idb/member/pocketMember/" + pocket.pocketId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          console.log("response " + JSON.stringify(response));
          console.log("SUCCESS!!!!!!! ");
          vm.heartArray.splice(vm.findHeartIndex(item), 1);
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log("!!!! " + error);
        });
    },
    findItemIndex(item) {
      let vm = this;
      let itemIndex = 0;
      vm.selectedArray.find(function(element, index) {
        if (item.uuid == element.uuid) itemIndex = index;
      });
      return itemIndex;
    },
    findHeartIndex(item) {
      let vm = this;
      let itemIndex = 0;
      vm.heartArray.find(function(element, index) {
        if (item.uuid == element.pocketMemberId) itemIndex = index;
      });
      return itemIndex;
    },
    selectedArrayPushObject(item) {
      var vm = this;
      var selectedFlag = false;
      vm.selectedArray.forEach(function(element) {
        if (element.plate == item.plate) {
          selectedFlag = true;
        }
      });
      if (!selectedFlag) {
        vm.selectedArray.push(item);
      }
    },
    nextPage() {
      if (this.currentPage + 1 <= this.maxPage) this.currentPage += 1;
      this.getInterpreterFromServer();
    },
    formerPage() {
      if (this.currentPage - 1 >= 1) this.currentPage -= 1;
      this.getInterpreterFromServer();
    },
    updateItemsPerPage(number) {
      this.pageSize = number;
      this.getInterpreterFromServer();
    },
    parentDialog() {
      this.dialog = !this.dialog;
    },
    getInterpreterFromServer() {
      var vm = this;

      if (vm.isNotBlankUtil("1")) {
        vm.searchObject();
        return;
      }
    },

    searchObject() {
      var vm = this;
      console.log("vm.queryObject " + JSON.stringify(vm.queryObject));
      if (JSON.stringify(vm.queryObject) != "{}") {
        vm.items = vm.fakeItems.filter(function(item) {
          return (
            item.plate
              .toUpperCase()
              .indexOf(vm.queryObject.plate.toUpperCase()) != -1
          ); // 取得大於五歲的
        });
      } else {
        vm.items = vm.fakeItems;
      }

      vm.totalCount = vm.items.length;
      //vm.currentPage = 1;
      //   vm.totalCount = 5;
      //   vm.pageSize = 4;
      vm.maxPage = Math.ceil(vm.totalCount / vm.pageSize);
      console.log("vm.maxPage " + vm.maxPage);
      //   vm.pageSize = 1;
    },
    initRegularMap() {
      // Satellite Map
      const myLatlng = new window.google.maps.LatLng(40.748817, -73.985428);
      const mapOptions = {
        zoom: 3,
        scrollwheel: false, // we disable de scroll over the map, it is a really annoing when you scroll through page
        center: myLatlng,
        mapTypeId: new window.google.maps.MapTypeId.SATELLITE()
      };

      const map = new window.google.maps.Map(
        document.getElementById("regularMap"),
        mapOptions
      );

      const marker = new window.google.maps.Marker({
        position: myLatlng,
        title: "Satellite Map!"
      });
      marker.setMap(map);
    },
    g2(google) {
      console.log("!!!!!!!!");
      //   const myLatlng = new window.google.maps.LatLng(40.748817, -73.985428);
      //   const google = loader.load();

      const myLatlng = google.maps.LatLng(40.748817, -73.985428);
      const mapOptions = {
        zoom: 8,
        center: myLatlng,
        scrollwheel: false // we disable de scroll over the map, it is a really annoing when you scroll through page
      };

      const map = google.maps.Map(
        document.getElementById("regularMap"),
        mapOptions
      );

      const marker = google.maps.Marker({
        position: myLatlng,
        title: "Regular Map!"
      });

      marker.setMap(map);
    },
    g3() {
      console.log("!!!!!!!!3");
      //   const myLatlng = new window.google.maps.LatLng(40.748817, -73.985428);
      //   const google = loader.load();

      //   loader.load().then(google => {
      //     console.log("!!!!!!!!4");
      //     const map = new google.maps.Map(document.getElementById("mapDiv"), {
      //       center: { lat: -34.397, lng: 150.644 },
      //       zoom: 8
      //     });
      //     const marker = new window.google.maps.Marker({
      //       position: new window.google.maps.LatLng(40.748817, -73.985428),
      //       title: "Regular Map!"
      //     });

      //     marker.setMap(map);
      //   });
    }
  },
  created() {
    var vm = this;
    // vm.updateUser("updateUserDDDD");
    // vm.updateTargetId("updateTargetId");
    vm.searchObject();
    // loader.load(google => {
    //   console.log("XXXXXXXXXXXXXX");
    //   vm.g2(google);
    // });
  },
  watch: {
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        setTimeout(function() {
          // that.screenWidth = that.$store.state.canvasWidth
          //console.log(that.screenWidth)
          //this.init()
          this.timer = false;
        }, 400);
      }
    },
    screenHeight(val) {
      if (!this.timer2) {
        this.screenHeight = val;
        this.timer2 = true;
        setTimeout(function() {
          // that.screenWidth = that.$store.state.canvasWidth
          //console.log(that.screenHeight)
          //this.init()
          this.timer2 = false;
        }, 400);
      }
    }
  },
  mounted() {
    var vm = this;

    // vm.initRegularMap();
    // loader.load().then(vm.g2(google));
    // const google = loader.load();
    // new google.maps.Map(document.getElementById("regularMap"), {
    //   center: { lat: -34.397, lng: 150.644 },
    //   zoom: 8
    // });
    // loader.load(google => {
    //   console.log("XXXXXXXXXXXXXX");
    //   vm.g2(google);
    // });

    vm.g3();

    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
        this.screenHeight = document.body.clientHeight;
      })();
    };

    // window.addEventListener("scroll", function() {
    //   var scrollPos = document.documentElement.scrollTop - 300;
    //   if (scrollPos < 0) scrollPos = 0;
    //   if (vm.selectedArray.length > 4) scrollPos = 0;
    //   vm.offsetTop = scrollPos;
    // });

    //test
    // console.log("vm.getSearchCase " + JSON.stringify(vm.getSearchCase));
    // console.log("vm.getQueryObject " + JSON.stringify(vm.getQueryObject));
    // if (vm.getQueryObject != null || vm.getSearchCase != null) {
    //   if (vm.getQueryObject != null)
    //     vm.queryObject = JSON.parse(JSON.stringify(vm.getQueryObject));
    //   if (vm.getSearchCase != null)
    //     vm.searchCase = JSON.parse(JSON.stringify(vm.getSearchCase));

    //   vm.districtObjectUtil(vm.queryObject.serviceCity);
    //   vm.getInterpreterFromServer();
    // }
    // vm.selectedArray = vm.getIcArray;

    // vm.getHeartList();
    // vm.$refs.form.validate();
  }
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}

.App {
  width: 100vw;
  height: 100vh;
}
</style>


